import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/ctaSection/ctaSection";
import Navbar2 from "../../components/Navbar2/Navbar2";
import PartnerSectionS2 from "../../components/PartnerSection2/PartnerSectionS2";
import FarmSection from "../../components/Company/Farm";
import WarehouseSection from "../../components/Company/Warehouse";
import SisterCompany from "../../components/Company/SisterCompany";
import img from "../../images/coffee-processing.jpg";

const TestimonialPage = (props) => {
  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-1"} />
      <PageTitle
        pageTitle={"Our Business"}
        pagesub={"Our Business"}
        img={img}
      />
      <FarmSection />
      <WarehouseSection />
      <SisterCompany />
      <CtaSection />
      <PartnerSectionS2 tNone={"partners-section-s2"} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default TestimonialPage;
